import { autoinject } from "aurelia-framework";
import { HospiceClient } from "../common/hospice-client";
import {
    IAxxessIntelligenceRecentSearchResponseBase,
    IAxxessIntelligenceSearchRequest,
    IAxxessIntelligenceSearchResponseBase,
    IAxxessIntelligenceUserTracker,
    IFeedbackResult,
    IGetAiTutorialFeedback,
    IIsAxxessFeatureLocked,
    IIsPremiumUser
} from "../interfaces/i-axxess-intelligence";

@autoinject()
export class AiService {
    private _httpClient: HospiceClient;
    private _baseUrl: string = "/api/v1/ask-axxess";
    private _baseUrlNew: string = "/api/v1/accounts";

    public constructor(httpClient: HospiceClient) {
        this._httpClient = httpClient;
    }

    public async getSearchInfo(query: IAxxessIntelligenceSearchRequest) {
        return await this._httpClient
            .build(`${this._baseUrl}/search`)
            .useQueryString(query)
            .fetch<IAxxessIntelligenceSearchResponseBase>();
    }

    public async getRecentSearches() {
        return await this._httpClient
            .build(`${this._baseUrl}/statistics`)
            .fetch<IAxxessIntelligenceRecentSearchResponseBase>();
    }

    public async feedbackResult(params: IFeedbackResult) {
        return await this._httpClient.build(`${this._baseUrl}/feedback`).useMethod("POST").useBody(params).fetch();
    }

    public async trackUserActions(params: IAxxessIntelligenceUserTracker) {
        return await this._httpClient
            .build(`${this._baseUrl}/track-user-action`)
            .useMethod("POST")
            .useBody(params)
            .fetch();
    }

    public async aiTourSeen() {
        return await this._httpClient.build(`${this._baseUrl}/tutorial`).fetch<IGetAiTutorialFeedback>();
    }

    public async isPremiumAiUser(accountId: string) {
        return await this._httpClient
            .build(`${this._baseUrlNew}/${accountId}/axxess-intelligence-status`)
            .fetch<IIsPremiumUser>();
    }

    public async isAxxessFeatureLocked() {
        return await this._httpClient.build(`${this._baseUrl}/within-usage-limit`).fetch<IIsAxxessFeatureLocked>();
    }
}
